export const baseStatusConst = {
  ALL: 0,
  TO_DO: 1,
  DOING: 2,
  DONE: 3,
}

const baseStatus = [
  { label: 'All', value: baseStatusConst.ALL },
  { label: 'ToDo', value: baseStatusConst.TO_DO },
  { label: 'Doing', value: baseStatusConst.DOING },
  { label: 'Done', value: baseStatusConst.DONE },
]

export default baseStatus
